import {
    type Embed,
    type Link,
    type NewEmbed,
    type NewLink,
    type NewUnityEmbed,
    type NewUnityLink,
    type NewUnityVideo,
    type NewVideo,
    type UnityEmbed,
    type UnityLink,
    type UnityVideo,
    type Video,
} from '@@api/services/externalContent/schemas';
import { getDefaultVariant } from '@@containers/TenantSpecific/arrayUtils';
import deserializeState from '@@plate/serialization/unity/utils/deserializeState';
import serializeState from '@@plate/serialization/unity/utils/serializeState';
import { isNormalLink } from '@@routes/externalContent/links/utils';

import { deserializeVariants, serializeVariants } from '../../utils/transformers';

export const deserializeEmbed = (entity: UnityEmbed): Embed => ({
    ...entity,
    variants: deserializeVariants(entity.variants, (variant) => ({
        ...variant,
        lead: deserializeState(variant.lead),
        allowAutomaticTeaserUpdate: true,
    })),
});

export const serializeEmbed = (entity: Embed): UnityEmbed => ({
    ...entity,
    variants: serializeVariants(entity.variants, (variant) => ({
        ...variant,
        lead: serializeState(variant.lead),
    })),
});

export const serializeNewEmbed = (entity: NewEmbed): NewUnityEmbed => ({
    ...entity,
    variants: serializeVariants(entity.variants, (variant) => ({
        ...variant,
        lead: serializeState(variant.lead),
    })),
});

export const deserializeLink = (entity: UnityLink): Link => {
    const variants = deserializeVariants(entity.variants, (variant) => variant);
    const type = isNormalLink(getDefaultVariant(variants).url || '') ? 'url' : 'deepLink';

    return {
        ...entity,
        variants,
        type,
    };
};

export const serializeLink = (entity: Link): UnityLink => ({
    ...entity,
    variants: serializeVariants(entity.variants, (variant) => variant),
});

export const serializeNewLink = (entity: NewLink): NewUnityLink => ({
    ...entity,
    variants: serializeVariants(entity.variants, (variant) => variant),
});

export const deserializeVideo = (entity: UnityVideo): Video => ({
    ...entity,
    variants: deserializeVariants(entity.variants, (variant) => ({
        ...variant,
        lead: deserializeState(variant.lead),
        intro: deserializeState(variant.intro),
        allowAutomaticTeaserUpdate: true,
    })),
    content: deserializeState(entity.content),
});

export const serializeVideo = (entity: Video): UnityVideo => ({
    ...entity,
    url: entity.url ?? null,
    variants: serializeVariants(entity.variants, (variant) => ({
        ...variant,
        lead: serializeState(variant.lead || []),
        intro: serializeState(variant.intro || []),
    })),
    content: serializeState(entity.content),
});

export const serializeNewVideo = (entity: NewVideo): NewUnityVideo => ({
    ...entity,
    url: entity.url ?? null,
    variants: serializeVariants(entity.variants, (variant) => ({
        ...variant,
        lead: serializeState(variant.lead || []),
        intro: serializeState(variant.intro || []),
    })),
    content: serializeState(entity.content),
});
